import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

import type { Assets } from '@/types';

const resultFunction = (
  tokens: Assets,
  getIsEnabled: (string) => boolean,
): Assets =>
  Object.fromEntries(
    Object.entries(tokens).filter(([, token]) => getIsEnabled(token.name)),
  );

const enabledDefinition = {
  id: 'enabled',
  resultFunction,
  dependencies: [
    //
    { selector: 'all' },
    { module: 'enabledAssets', selector: 'getIsEnabled' },
  ],
} as const satisfies SelectorDefinition;

export default enabledDefinition;
